export default __webpack_public_path__ + "static/media/exterior-5.5b1dfe86.webp";